<template>
  <v-container
    class="pa-0 metric-summary-view"
    align-center
    justify-center
    fill-height
  >
    <v-layout class="pa-0" v-if="!loading && !noData" column>
      <v-layout align-center justify-center wrap>
        <v-flex md5 sm12>
          <pie-chart
            style="height: 300px; width: 300px;margin: auto"
            v-if="!loading"
            :data="chartData"
            :options="chartOptions"
          ></pie-chart>
        </v-flex>
        <v-flex md7 sm12 class="pr-3 mt-2">
          <v-layout column>
            <v-flex
              class="mb-2 question-area"
              v-if="metricQuestions.length > 0"
            >
              <QuestionRenderer
                :question="metricQuestions[0].question"
                :placeholders="{
                  brand_name: $store.getters['user/currentCampaign'].brand_name
                }"
              ></QuestionRenderer>
            </v-flex>
            <v-flex class="table-area">
              <SummaryTable
                :headers="['Segment', 'Count', 'Percentage']"
                :rows="table"
              ></SummaryTable>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout align-center v-if="!loading && !noData" justify-center>
        <v-flex
          ><MetricNumber
            change-indicator
            :number="insights.metric.change_over_period"
            label="Changeover period"
            append="%"
          ></MetricNumber
        ></v-flex>
        <v-flex
          ><MetricNumber
            :changeIndicator="false"
            :number="insights.metric.count"
            :label="'Total ' + chartOptions.centerText.label + ' Responses'"
          ></MetricNumber
        ></v-flex>
        <v-flex>
          <MetricNumber
            :changeIndicator="false"
            :number="insights.metric.response_rate"
            :label="chartOptions.centerText.label + ' Response Rate'"
            append="%"
          ></MetricNumber
        ></v-flex>
      </v-layout>
    </v-layout>
    <v-progress-circular indeterminate v-if="loading"></v-progress-circular>
    <NoResult v-if="!loading && noData"></NoResult>
  </v-container>
</template>

<script>
import routes from '@/route_names'
import PieChart from '@/components/insights/PieChart.js'
import SummaryTable from '@/components/insights/SummaryTable'
import constants from '@/constants'
import insightsApi from '@/api/insights'
import QuestionRenderer from '@/components/QuestionRenderer'
import MetricNumber from '@/components/insights/MetricNumber'
import NoResult from '@/components/insights/NoResult'
import filterMixins from '@/mixins/filter'
export default {
  name: 'SummaryView',
  mixins:[filterMixins],
  components: {
    PieChart,
    QuestionRenderer,
    MetricNumber,
    SummaryTable,
    NoResult
  },
  data() {
    
    return {
      loading: true,
      metricType: null,
      
      chartOptions: {
        centerText:  {
          label: 'NPS',
          score: 0
          },
        legend: false,
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
            callbacks: {
                label: function(item, data) {
                  
                    console.log(item, data)
                    let base =
                      data.labels[item.index] + ': <b>' + data.datasets[item.datasetIndex].data[item.index] + '%</b>'

                    if (data.datasets[item.datasetIndex].counts)
                      base += '(' + data.datasets[item.datasetIndex].counts[item.index] + ')'
                    return base
                }
            }
        }
      },
      chartData: {
        labels: [],
        datasets: [
          {
            label: '',
            backgroundColor: [
              constants.colors.rated1,
              constants.colors.rated2,
              constants.colors.rated3,
              constants.colors.rated4,
              constants.colors.rated5
            ],
            data: []
          }
        ]
      },
      
      noData: false,
      insights: {},
      metricQuestions: [],
      table: []
    }
  },

  created() {
    if (
      this.$router.currentRoute.name === routes.INSIGHTS_METRICS_NPS_SUMMARY
    ) {
      this.metricType = 'nps'
      this.chartOptions.centerText.label = 'NPS'
      this.chartData.datasets[0].backgroundColor = [
        constants.colors.rated1,
        constants.colors.rated3,
        constants.colors.rated5
      ]
    } else if (
      this.$router.currentRoute.name === routes.INSIGHTS_METRICS_CSAT_SUMMARY
    ) {
      this.metricType = 'sat'
      this.chartOptions.centerText.label = 'CSAT'
    } else if (
      this.$router.currentRoute.name === routes.INSIGHTS_METRICS_CES_SUMMARY
    ) {
      this.chartOptions.centerText.label = 'CES'

      this.metricType = 'es'
    }
    this.getData()
    const vm = this
    this.$store
      .dispatch('campaign/getQuestions', {
        campaignId: this.$router.currentRoute.params.campaignId,
        type: this.metricType.toUpperCase()
      })
      .then(function(data) {
        vm.metricQuestions = data.questions
      })
  },
  watch: {
    $route: function() {
      this.getData()
    }
  },
  methods: {
    getData() {
      const vm = this
      vm.loading = true
      insightsApi
        .getMetricSummary({
          campaignId: this.$router.currentRoute.params.campaignId,
          metricType: this.metricType,
          query: {
            from: this.$router.currentRoute.query.from,
            to: this.$router.currentRoute.query.to,
            ...this.getAttributeFilters()
          }
        })
        .then(function(res) {
          const results = res.data.results
          vm.insights = results
          if (results.metric.score === 'NO_RESULT') {
            vm.noData = true
            vm.loading = false
            return
          } else {
            vm.noData = false
          }
          if (results.metric.change_over_period === 'NO_RESULT') {
            results.metric.change_over_period = null
          }
          if (results.metric && results.metric.labels) {
            vm.chartData.labels = results.metric.labels.map(d => d.label)
            vm.chartData.datasets[0].data = results.metric.labels.map(
              d => d.percent
            )
            vm.chartData.datasets[0].counts = results.metric.labels.map(
              d => d.count
            )
            vm.chartOptions.centerText.score = results.metric.score
          }
          vm.buildTable(results)
          vm.loading = false
        })
    },
    buildTable: function(insights) {
      const vm = this
      const labels = insights.metric.labels.map(function(d, i) {
        d.color = vm.chartData.datasets[0].backgroundColor[i]
        return d
      })
      this.table = labels.reverse()
    }
  }
}
</script>

<style lang="stylus">
.metric-summary-view {
    .question-area {
        color: $color-primary-light-5
        font-size 16px
        text-align left
    }
    .table-area {
        color: $color-primary-light-1
        font-size 16px
        .count, .percent {
            font-weight 500
        }

    }
}
</style>
